<script setup>
import { LinkGraySm } from "@easy/ui/links";
import { LinkShareIcon } from "@easy/ui/icons";
import { FilterSearch } from "@easy/ui/filters";
import { debouncedWatch } from "@vueuse/core";
import { ref } from "vue";

defineProps({
    modelValue: String,
    placeholder: String,
    linkToPlayer: String,
});
const emit = defineEmits(["update:modelValue"]);

const query = ref("");
debouncedWatch(
    query,
    (val) => {
        emit("update:modelValue", val);
    },
    { debounce: 400 }
);
</script>

<template>
    <div class="flex items-center py-3.5 px-5 sm:px-6 space-x-6 border-b ct-border-2">
        <FilterSearch v-model="query" :placeholder="placeholder" />
        <a :href="linkToPlayer">
            <LinkGraySm>
                <LinkShareIcon />
                <span>{{ $t("player.panel.preview") }}</span>
            </LinkGraySm>
        </a>
    </div>
</template>
